import { useEffect, useState } from "react";

const useCounter = (end, duration) => {
	const [count, setCount] = useState(0);

	useEffect(() => {
		let start = 0;
		let current = start;
		let range = end - start;
		let increment = end > start ? 1 : -1;
		let step = Math.abs(Math.floor(duration / range));
		const timer = setInterval(() => {
			current += increment;
			setCount(current);
			if (current === end) {
				clearInterval(timer);
			}
		}, step);
	}, []);

	return { count };
};

export default useCounter;
